var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var MessageListItem = require('./messageListItem.jsx');

var MessageList = createReactClass({
    mixins: [PureRenderMixin],

    render: function () {

        var messageListItemNodes = this.props.messages.map(function(message){
            return (
                <MessageListItem
                    message={message}
                    key={message._id}
                    tags={this.props.tags}
                    targets={this.props.targets}
                    setMessage={this.props.setMessage} />
            );
        }.bind(this));

        return (
            <ul className="message-list no-bullet">
                {messageListItemNodes.length ? messageListItemNodes : <li>no messages to show</li>}
            </ul>
        );
    }
});

module.exports = MessageList;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/messageList.jsx